import { MoratoriumSearchRequestQuery, MoratoriumEventSearchRequestQuery } from '@lio/api-types';

export const MoratoriumEventsKey = {
  search: ['moratorium-events'] as const,
  searchParams: (params: MoratoriumEventSearchRequestQuery) => [...MoratoriumEventsKey.search, params] as const,
};

export const MoratoriumKey = {
  search: ['moratoriums'] as const,
  searchParams: (params: MoratoriumSearchRequestQuery) => [...MoratoriumKey.search, params] as const,
};

export const MoratoriumFilesKey = {
  search: ['moratorium-files'] as const,
  searchParams: (params: MoratoriumFilesSearchRequestQuery) => [...MoratoriumFilesKey.search, params] as const,
};

export const QuoteMoratoriumKey = {
  get: (quoteId?: string) => ['quote-moratorium', quoteId] as const,
};

// Add the interface for moratorium files search query
export interface MoratoriumFilesSearchRequestQuery {
  searchText?: string;
  fileName?: string;
  pageLimit?: number;
  pageOffset?: number;
  sort?: string;
}
